// Loads the Razorpay checkout.js script on demand and opens the modal.

let _rzpPromise = null;

export function loadRazorpay() {
  if (_rzpPromise) return _rzpPromise;
  _rzpPromise = new Promise((resolve, reject) => {
    if (typeof window !== "undefined" && window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => {
      if (window.Razorpay) resolve(window.Razorpay);
      else reject(new Error("Razorpay not available"));
    };
    s.onerror = () => reject(new Error("Failed to load Razorpay checkout.js"));
    document.body.appendChild(s);
  });
  return _rzpPromise;
}

// Opens Razorpay checkout. Returns a promise that resolves with { success, response, error }
export async function openRazorpay({
  keyId,
  amountPaise,
  currency = "INR",
  razorpayOrderId,
  name = "AuthorOS by Zebralearn",
  description = "Studio Plan",
  prefill = {},
  theme = { color: "#ff4e15" },
}) {
  const Razorpay = await loadRazorpay();
  return new Promise((resolve) => {
    const options = {
      key: keyId,
      amount: amountPaise,
      currency,
      name,
      description,
      prefill,
      theme,
      handler: (response) => {
        resolve({ success: true, response });
      },
      modal: {
        ondismiss: () => resolve({ success: false, dismissed: true }),
      },
    };
    if (razorpayOrderId) options.order_id = razorpayOrderId;
    try {
      const rzp = new Razorpay(options);
      rzp.on("payment.failed", (resp) => resolve({ success: false, error: resp.error }));
      rzp.open();
    } catch (e) {
      resolve({ success: false, error: { description: e.message } });
    }
  });
}
